import React from "react";
import {Col, FormFeedback, Input, Row} from "reactstrap";
import {withTranslation} from "react-i18next";
import {getShopInfosInStorage} from "tunnel-commande/src/components/cart/ShopInfos";
import Modal from "react-responsive-modal";
import PriceList from "./PriceList";
import ShopRepository from "../../repositories/shop/ShopRepository";
import {withHostApi} from "../../contexts/HostApiContext";

class NombreInput extends React.Component<any, any> {

  private readonly quantiteMin: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      quantite: this.props.quantite,
      openTarifs: false,
      priceTable: null
    }

    this.quantiteMin = getShopInfosInStorage() ? getShopInfosInStorage().quantiteMin : 10;

    this.handleOnFormChange = this.handleOnFormChange.bind(this);
  }

  componentDidMount() {
    if(!this.props.onlyGrid) {
      const shopRepository = new ShopRepository();
      shopRepository.fetchPriceTable(this.props.hostApi, this.props.productId).then((res) => {
        this.setState({priceTable: res});
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any): void {
    if(prevProps.quantite !== this.props.quantite) {
      this.setState({
        quantite: this.props.quantite
      })
    }
  }

  private handleOnFormChange(e: any) {
    if(this.props.onChange) {
      this.props.onChange(e);
    }
  }

  render() {
    return (
      <>
    <div className={` ${!this.props.onlyGrid ? 'd-flex' : ''}  flex-grow-1 justify-content-between align-items-center`}>
      {!this.props.fileUploaded && this.props.qtepriceFrom?.quantite ? (
        <div  className={`opac30`}>
        <Input bsSize={"lg"} disabled={true} className={`border-dark input-dt-cmd mr-4`} placeholder={this.props.qtepriceFrom.quantite} type={"number"}/>
        </div>
      ) : (
          <>
            <Input id={"input_qte"} bsSize={"lg"} disabled={this.props.disabled} className={'border-dark input-dt-cmd mr-4'} placeholder={'0'} step={this.quantiteMin} min={this.quantiteMin} max={30000} invalid={this.props.quantite != 0 && this.props.quantite < this.quantiteMin  } valid={this.props.quantite >= this.quantiteMin} value={ this.state.quantite} onChange={this.handleOnFormChange} name={"quantite"} type={"number"}/>
            <FormFeedback className={'m0 align-self-center'}>
              <div className={'position-relative'}>
                <div className={'d-flex position-absolute align-items-center'}>
                  {this.props.t('pieces_minimum').replace('PM', this.quantiteMin)}
                </div>

              </div>
            </FormFeedback>
          </>
        )}
    </div>

    <Modal open={this.props.showModal} onClose={this.props.onCloseModalTarifs} classNames={{modal: "modalPriceList"}}  center>
      <Row className={'m-0'}>
        <Col xs={12}>
          <PriceList onlyGrid={true} priceTable={this.state.priceTable}/>
        </Col>
        <Col xs={12}>
          <button className={'font20 w100 btn-dt-primary btn btn-secondary mb-3 btn-block d-md-none'}
             onClick={this.props.onCloseModalTarifs}>{this.props.t('close')}</button>
        </Col>
      </Row>
    </Modal>
    </>
    );
  }
}
export default withTranslation('common')(withHostApi(NombreInput));
